import { OptionSetGroup } from './option-set-group';
import { Choices } from './choice';
import { ContentId } from './content-block';
import { ContentTreeNode } from './content-tree-node';
import { FormsConstants } from './forms-constants';

export type FunctionalElement = FunctionalElementBase &
    (FunctionalElementAstoria & FunctionalElementCosima) &
    ContentTreeNode;

export type FunctionalElementBase = Readonly<{
    id: ContentId;
    type: FUNCTIONAL_ELEMENT_TYPE; // TODO: Check if refactoring to using generics is useful?
    controllingOption: ContentId | undefined;
    contentLoadedFromXml: boolean;
    disabled: boolean;
    visible?: boolean;
}>;

export type FunctionalElementAstoria = Readonly<{
    controllingCheckpoint: string;
}>;

export type FunctionalElementCosima = Readonly<{
    xmlId?: string; // the id of the e-result element in the XML
    remarks?: string; // the value of the remarks field
    remarksLabel?: string; // the label of the remarks field
    remarksXmlId?: string; // the id of the remarks element in the XML
    choices?: Choices;
    elementType?: FormsConstants.ELEMENT_TYPE; // the type for use with the filters
    optionSet?: OptionSetGroup[];
    visible?: boolean;
}>;

export enum FUNCTIONAL_ELEMENT_TYPE {
    STANDARD = 'STANDARD', // used in Cosima instead of checkpoints
    REMARK = 'REMARK', // used in cosima - standard functional element with remarks field always displayed
    DISCREPANCY_LOG = 'DISCREPANCY_LOG',
    EMPLOYEE_SIGNATURE = 'EMPLOYEE_SIGNATURE', // used in Cosima
    APPROVER_SIGNATURE = 'APPROVER_SIGNATURE', // used in Cosima
    SIGNOFF_EMPLOYEE = 'SIGNOFF_EMPLOYEE',
    SIGNOFF_CUSTOMER = 'SIGNOFF_CUSTOMER',
    SIGNOFF_EMPLOYEE_SYSTEM_CONDITION = 'SIGNOFF_EMPLOYEE_SYSTEM_CONDITION',
    SIGNOFF_CUSTOMER_SYSTEM_CONDITION = 'SIGNOFF_CUSTOMER_SYSTEM_CONDITION',
    COMPONENT = 'COMPONENT', // used in Cosima instead of MATERIAL_SERIAL_NO
    MATERIAL_SERIAL_NO = 'MATERIAL_SERIAL_NO',
    MATERIAL_SERIAL_NO_WITH_DESC = 'MATERIAL_SERIAL_NO_WITH_DESC',
    DATE = 'DATE', // used in Cosima to represent the date functional element
    DATE_PERFORMED = 'DATE_PERFORMED', // used in Astoria
    REPLACEMENT_DATE = 'REPLACEMENT_DATE', // used in Astoria
    LAST_PROCEDURE_DATE = 'LAST_PROCEDURE_DATE', // used in Astoria
    VALUE = 'VALUE', // used in Astoria and Cosima
    VALUE_UNIT = 'VALUE_UNIT', // used in Astoria
    OPTION = 'OPTION', // used in Astoria
    OPTION_PRESENT = 'OPTION_PRESENT', // used in Cosima
    WORKSTEPS_PERFORMED = 'WORKSTEPS_PERFORMED', // used in Astoria
    DEFECTIVE_COMPONENT_REPLACEMENT = 'DEFECTIVE_COMPONENT_REPLACEMENT', // used in Cosima
    DROP_DOWN_OPTIONS = 'DROP_DOWN_ANSWERS',
}
